import { NATIVE_SCOREBOARD_PERIOD_TYPE, LIVE_SCORE_FIELD_MAPPING, TOTAL, SCORE_TYPE_PERIOD, EVENT_MATCH_STATUS_TYPES } from 'Store/constants/sportTypes';

/**
 * Masa tenisi için periodType'dan title formatına çevirme
 * SET1 -> S1, SET2 -> S2, etc.
 */
const mapPingPongPeriodTypeToTitle = periodType => {
  if (!periodType || typeof periodType !== 'string') return null;
  
  // SET1, SET2, SET3 -> S1, S2, S3
  const match = periodType.match((/^SET(\d+)$/i));
  if (match) {
    return `S${match[1]}`;
  }
  
  return null;
};

export const updateWithSocketScoreBoard = (score, currentScore)=> {
  if (!score || !Array.isArray(score)) {
    return score;
  }

  // Masa tenisi için POST_GAME kontrolü (maç bitti)
  const isPingPongPostGame = currentScore.periodType === 'POST_GAME'
                              && (currentScore.matchStatus === 'PLAYED' || currentScore.matchStatus === 'FINISHED');
  
  if (isPingPongPostGame && currentScore?.away?.toString() && currentScore?.home?.toString()) {
    // Maç bittiğinde sadece "Skor" satırını güncelle
    const newScore = score.map(item => {
      if (item.title === 'Skor') {
        item.awayScore = currentScore.away;
        item.homeScore = currentScore.home;
      }
      return item;
    });
    return newScore;
  }

  if (currentScore?.currentPeriodAway?.toString() &&  currentScore?.away?.toString()) {
    const isVolleyballOrTableTennis = NATIVE_SCOREBOARD_PERIOD_TYPE.includes(currentScore.title);
    
    // Masa tenisi için periodType'dan title belirle
    const isPingPong = currentScore.periodType && (/^SET\d+$/i).test(currentScore.periodType);
    const pingPongTitle = isPingPong ? mapPingPongPeriodTypeToTitle(currentScore.periodType) : null;
    
    let tempTitle = '';
    
    if (pingPongTitle) {
      tempTitle = pingPongTitle;
    } else if (isVolleyballOrTableTennis) {
      tempTitle = currentScore.title;
    } else {
      tempTitle = currentScore.title.substr(0, currentScore.title?.length - 1);
    }


    const newScore = score.map(item => {
      if (item.title === tempTitle) {
        item.awayScore = currentScore.currentPeriodAway;
        item.homeScore =  currentScore.currentPeriodHome;
        return item;
      } else if (item.title === 'Skor') {
        item.awayScore = currentScore.away;
        item.homeScore = currentScore.home;
        return item;
      } else if ((isVolleyballOrTableTennis || isPingPong) && item.title === 'Toplam') {
        item.awayScore = currentScore.totalSetScoreAway?.toString();
        item.homeScore = currentScore.totalSetScoreHome?.toString();
        return item;
      } else {
        return item;
      }
    });

    const foundScore = score.filter(item => {
      if (item.title === tempTitle) {
        return item;
      }
    });

    if (foundScore?.length === 0 ) {
      const newScoreObj = {
        awayScore: currentScore.currentPeriodAway,
        homeScore: currentScore.currentPeriodHome,
        title: tempTitle
      };
      
      if (isPingPong && currentScore.periodType) {
        const setMatch = currentScore.periodType.match(/^SET(\d+)$/i);
        if (setMatch) {
          newScoreObj.scoreName = `TABLE_TENNIS_SET${setMatch[1]}`;
        }
      }
      
      if (isVolleyballOrTableTennis || isPingPong) {
        let insertIndex = newScore.length - 2;
        
        if (isPingPong && newScoreObj.scoreName) {
          const sets = [];
          let skor = null;
          
          newScore.forEach(item => {
            if (item.title === 'Skor') {
              skor = item;
            } else if (item.scoreName?.startsWith('TABLE_TENNIS_SET')) {
              sets.push(item);
            }
          });
          
          sets.push(newScoreObj);
          
          sets.sort((a, b) => {
            const aMatch = a.scoreName?.match(/TABLE_TENNIS_SET(\d+)/);
            const bMatch = b.scoreName?.match(/TABLE_TENNIS_SET(\d+)/);
            if (aMatch && bMatch) {
              return parseInt(aMatch[1]) - parseInt(bMatch[1]);
            }
            return 0;
          });
          
          const result = [...sets];
          if (skor) result.push(skor);
          
          return result;
        }
        
        newScore.splice(insertIndex, 0, newScoreObj);
      } else {
        newScore.splice(score?.length - 1, 0, newScoreObj);
      }
      
    }
   
    return newScore;
  }
  return score;
};

/**
 * Merges normalized liveScores into the existing scores array.
 * Called internally by updateWithSocket after ps/ts normalization.
 * Handles variable-length arrays; each entry is either scoreType PERIOD or TOTAL.
 *
 * PERIOD: matched by periodNumber + periodType → update if exists, insert in order if new
 * TOTAL:  matched by scoreType === TOTAL       → update if exists, append if missing
 */
const mergeScores = (currentScores, incomingScores) => {
  const result = [...currentScores];

  incomingScores.forEach(wsScore => {
    if (wsScore.scoreType === TOTAL) {
      const idx = result.findIndex(s => s.scoreType === TOTAL);
      if (idx >= 0) {
        result[idx] = { ...result[idx], ...wsScore };
      } else {
        result.push(wsScore);
      }
    } else if (wsScore.scoreType === SCORE_TYPE_PERIOD) {
      const idx = result.findIndex(
        s => s.scoreType === SCORE_TYPE_PERIOD
          && s.periodNumber === wsScore.periodNumber
          && s.periodType === wsScore.periodType
      );
      if (idx >= 0) {
        result[idx] = { ...result[idx], ...wsScore };
      } else {
        const isHalfSummary = wsScore.periodType === 'HALF';
        const insertIdx = result.findIndex(
          s => s.scoreType === TOTAL || (!isHalfSummary && s.scoreType === SCORE_TYPE_PERIOD && s.periodNumber > wsScore.periodNumber)
        );
        if (insertIdx >= 0) {
          result.splice(insertIdx, 0, wsScore);
        } else {
          result.push(wsScore);
        }
      }
    }
  });

  return result;
};

export const updateWithAggregate = (state, value) => {
  const aggregateData = value.aggregate || value.aggregateScores;
  const currentScore = state.data.liveMatchInfo?.scores;

  if (!Array.isArray(currentScore)) {
    return state;
  }

  const updatedScore = currentScore.map(item => {
    if (item.scoreType === TOTAL) {
      return {
        ...item,
        homeScore: String(aggregateData.homeTeam ?? item.homeScore),
        awayScore: String(aggregateData.awayTeam ?? item.awayScore),
      };
    }
    return item;
  });

  return {
    ...state,
    data: {
      ...state.data,
      liveMatchInfo: {
        ...state.data.liveMatchInfo,
        scores: updatedScore,
      },
    },
  };
};

/**
 * Tek entry point — gelen WS mesajına göre scores ve/veya aggregate günceller.
 * ps/ts ve aggregate aynı mesajda gelebileceğinden bağımsız olarak sırayla işlenir.
 */
export const updateWithSocketMessage = (state, value) => {
  let nextState = state;

  if (value.ps || value.ts) {
    nextState = updateWithSocket(nextState, value);
  }

  if (value.aggregate || value.aggregateScores) {
    nextState = updateWithAggregateV2(nextState, value);
  }

  return nextState;
};

/**
 * V2-specific aggregate handler.
 * Socket'ten gelen aggregate verisini state.data.aggregate olarak saklar.
 * scores array'ini etkilemez — TOTAL skor sadece ts objesinden beslenir.
 */
export const updateWithAggregateV2 = (state, value) => {
  const aggregateData = value.aggregate || value.aggregateScores;
  if (!aggregateData) return state;

  return {
    ...state,
    data: {
      ...state.data,
      aggregate: {
        homeTeam: aggregateData.homeTeam,
        awayTeam: aggregateData.awayTeam,
      },
    },
  };
};

export const updateWithScoreDetail = (state, value) => {
  const updates = Array.isArray(value.scoreDetail) ? value.scoreDetail : [value.scoreDetail];
  const merged = updates.reduce((acc, update) => {
    const index = acc.findIndex(s => s.shortTitle === update.shortTitle);
    if (index !== -1) {
      const next = [...acc];
      next[index] = { ...next[index], ...update };
      return next;
    }
    return [...acc, update];
  }, [...state.data.liveMatchInfo.scores]);

  const updatedScores = merged.sort((a, b) => {
    if (a.scoreType === TOTAL) return 1;
    if (b.scoreType === TOTAL) return -1;
    return (a.periodNumber || 0) - (b.periodNumber || 0);
  });

  return {
    ...state,
    data: {
      ...state.data,
      liveMatchInfo: {
        ...state.data.liveMatchInfo,
        scores: updatedScores,
        state: {
          ...state.data.liveMatchInfo?.state,
          status: {
            ...state.data.liveMatchInfo?.state?.status,
            code: value.matchStatus ?? state.data.liveMatchInfo?.state?.status?.code,
          },
          clock: {
            ...state.data.liveMatchInfo?.state?.clock,
            matchTime: value.time ?? state.data.liveMatchInfo?.state?.clock?.matchTime,
          },
        },
      },
    },
  };
};

/**
 * ps/ts objelerini mevcut liveScores array formatına çevirir.
 * ps → PERIOD entry, ts → TOTAL entry
 */
export const parseLiveScoreFromWS = value => {
  const F = LIVE_SCORE_FIELD_MAPPING;
  const result = [];

  if (value.ps) {
    const ps = value.ps;
    result.push({
      scoreType: ps.scoreType || SCORE_TYPE_PERIOD,
      periodNumber: ps[F.periodNumber],
      periodType: ps[F.periodType],
      homeScore: ps[F.homeScore],
      awayScore: ps[F.awayScore],
      shortTitle: ps[F.shortTitle],
      totalScore: ps[F.totalScore],
    });
  }

  if (value.ts) {
    const ts = value.ts;
    result.push({
      scoreType: ts.scoreType || TOTAL,
      homeScore: ts[F.homeScore],
      awayScore: ts[F.awayScore],
      shortTitle: ts[F.shortTitle],
      totalScore: ts[F.totalScore],
    });
  }

  return result;
};

/**
 * ps/ts formatındaki WS mesajını işler.
 * Sadece scores günceller — aggregate sorumluluğu updateWithSocketMessage'da.
 */
export const updateWithSocket = (state, value) => {
  const liveScores = parseLiveScoreFromWS(value);
  if (!liveScores.length) return state;

  return updateWithLiveEventDetails(state, {
    matchStatus: value.matchStatus,
    periodType: value.periodType,
    time: value.time,
    title: value.title,
    shortTitle: value.shortTitle,
    liveEventDetails: { liveScores },
  });
};

export const updateWithLiveEventDetails = (state, value) => {
  const incomingScores = value.liveEventDetails.liveScores;

  if (!Array.isArray(incomingScores) || incomingScores.length === 0) {
    return state;
  }

  const isMatchFinished = EVENT_MATCH_STATUS_TYPES.PLAYED.includes(value.matchStatus);
  const currentScores = state.data.liveMatchInfo?.scores || [];

  const scoresToMerge = isMatchFinished
    ? incomingScores
    : incomingScores.filter(wsScore => {
      if (wsScore.scoreType !== SCORE_TYPE_PERIOD) return true;
      const existsInState = currentScores.some(
        s => s.scoreType === SCORE_TYPE_PERIOD
          && s.periodNumber === wsScore.periodNumber
          && s.periodType === wsScore.periodType
      );
      if (existsInState) return true;
      // HALF periodType normalde yeni INSERT'e kapalı (futbol/hentbol — MS maç bitince gösterilmeli)
      // Ancak maç devre arasındaysa (HALF_TIME_BREAK/HALF_TIME) HALF özet skoru insert edilebilir (basketbol)
      // QUARTER, SET vb. yeni period geldiğinde normal olarak eklenir (basketbol, voleybol, masa tenisi)
      const isAtHalfTime = value.periodType === 'HALF_TIME_BREAK' || value.periodType === 'HALF_TIME';
      return wsScore.periodType !== 'HALF' || isAtHalfTime;
    });

  const mergedScores = mergeScores(currentScores, scoresToMerge);

  return {
    ...state,
    data: {
      ...state.data,
      liveMatchInfo: {
        ...state.data.liveMatchInfo,
        scores: mergedScores,
        state: {
          ...state.data.liveMatchInfo?.state,
          status: {
            ...state.data.liveMatchInfo?.state?.status,
            code: value.matchStatus?.toUpperCase() ?? state.data.liveMatchInfo?.state?.status?.code,
            shortDisplay: value.shortTitle ?? value.title ?? state.data.liveMatchInfo?.state?.status?.shortDisplay,
            display: value.title ?? state.data.liveMatchInfo?.state?.status?.display,
          },
          clock: {
            ...state.data.liveMatchInfo?.state?.clock,
            matchTime: value.time || null,
            periodTime: value.time || null,
          },
        },
      },
    },
  };
};
